import CustomInput from "../../components/CustomInput/Input";
import {
    panRules,
    gstinRules
} from "../../helpers/helpers";
import { isInvoiceStyleCategory } from "../../helpers/dealCategoryProducts";

const DealInformation = ({ dealTypeId }) => {
    const showGstin = isInvoiceStyleCategory(dealTypeId);

    return (
        <>
            <CustomInput
                label="Company PAN"
                name="busPan"
                type="text"
                isRequired={true}
                placeholder="Enter your Company PAN"
                rules={panRules}
                isUpperCase={true}
            />
            {showGstin && (
                <CustomInput
                    label="Company GSTIN"
                    name="gstin"
                    type="text"
                    isRequired={true}
                    placeholder="Enter your Company GSTIN"
                    rules={gstinRules}
                    isUpperCase={true}
                />
            )}
        </>
    );
};

export default DealInformation;
